// extracted by mini-css-extract-plugin
export default {"chat_body":"SurveyFrame_chat_body__aMrVZ","end_screen":"SurveyFrame_end_screen__dFvXh","action_element":"SurveyFrame_action_element__PgPS7"};